import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'
import PolicyPDFExportPublic from '@/pages/export/policy-pdf-public'

const searchSchema = z.object({
  policyDocumentId: z.string().optional(),
  token: z.string().optional(),
})

export const Route = createFileRoute('/export/policy-pdf/')({
  validateSearch: searchSchema,
  component: PolicyPDFExportPublic,
})
